<template>
	<h1>Types de Question pour fiche d'exercice</h1>
	<table>
		<tr>
			<th></th>
			<th>Nom</th>
			<th>Modifier</th>
			<th>Supprimer</th>
		</tr>
		<tr
			v-for="(questionType, index) in this.$store.state
				.exerciseQuestionTypes"
			:key="index"
		>
			<td>{{ index + 1 }}</td>
			<td>{{ questionType.name }}</td>
			<td>
				<router-link
					:to="{
						name: 'SuperAdminEditExerciseSheetQuestionType',
						params: { id: questionType.id },
					}"
					>Modifier</router-link
				>
			</td>
			<td>
				<button @click="deleteQuestionTheme(questionType.id)">
					supprimer
				</button>
			</td>
		</tr>
	</table>
</template>

<script>
import { authenticatedApiFetch } from '../../utils/utils'

export default {
	methods: {
		deleteQuestionTheme(e) {
			if (confirm("Do you really want to delete?")) {
				authenticatedApiFetch(`/exercise-question-types/${e}/`, { method: 'DELETE' })
					.then(() => {
						this.$store.dispatch('getExerciseSheetTypes')
					})
			}
		},
	},
}
</script>

<style>
</style>
